
import { Component, Provide, Vue } from 'vue-property-decorator'
import FillgridFiltersComponent from '@/components/fillgrid/fillgrid-filters.vue'
import FillgridViews from '@/components/fillgrid/fillgrid-views.vue'
import MediaPreview from '@/components/fillgrid/media-preview.vue'
import FillGridMap from '@/components/fillgrid/FillGridMap.vue'
import FillGridMapAside from '@/components/fillgrid/FillGridMapAside.vue'
import InputFormValue from '@/components/forms/input-form-value.vue'
import TopToolBarPaginator from '@/components/generic/TopToolBarPaginator.vue'
import fillgridService from '@/services/FillgridService'
import cookiesService, { BM_COOKIES } from '@/services/support/CookiesService'
import { FillgridColumn, FillgridFilters, FillgridSearchFilters, TemplateQuestionsTypes } from '@/types/Fillgrid'
import { CursorRequest, PageRequest } from '@/types/Support'
import userInfoStore from '@/store/userInfo'
import config from '@/config'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import moment from 'moment'
import { PROCESS_STATUS, UNDEFINED_ENTITY_ID, UserCatalogFilters } from '@/types/Catalogs'
import { PermissionNames, RoleNames } from '@/types/Auth'
import AsyncTaskFillgrid from '@/components/fillgrid/AsyncTaskFillgrid.vue'
import { AsyncTask } from '@/types/catalogs/AsyncTask'
import { CustomSearch, SearchOrigin } from '@/types/catalogs/CustomSearch'
import { APIErrorFormat } from '@/types/Errors'
import { NUMBER } from '@/types/GeneralConstants'
import LogService from '@/services/support/LogService'
import { AttachmentObject, SelectableAttachments, VariableFill } from '@/types/catalogs/Attachment'
import NotAllowedView from '@/components/permissions/NotAllowedView.vue'
import { NOT_ALLOWED_VIEW } from '@/types/viewAccess/AccessFailed'
import localStorageUser from '@/store/localStoreUser'
import { CONFIGURATION_KEY } from '@/types/Configuration'
import Normalizer from '@/types/Normalizer'
import { Template } from '@/types/Templates'

const MAX_SIMULTANEUS_REQUESTS = 10
const TIME_SIMULTANEUS_REQUESTS_WAIT = 3000

// eslint-disable-next-line
enum FILL_UPDATE_MODE {
  // eslint-disable-next-line
  MODIFY = 'modificar',
  // eslint-disable-next-line
  MANAGE = 'gestionar'
}

@Component({
  components: {
    IntegrationTask: () => import('@/components/fillgrid/IntegrationTask.vue'),
    FillgridFiltersComponent,
    FillgridViews,
    InputFormValue,
    TopToolBarPaginator,
    LoadingMask,
    MediaPreview,
    FillGridMap,
    FillGridMapAside,
    AsyncTaskFillgrid,
    NotAllowedView,
    LazyImage: () => import('@/components/fillgrid/LazyImage.vue'),
    LazyPDF: () => import('@/components/fillgrid/LazyPDF.vue')
  }
})
export default class Fillgrid extends Vue {
  template: Template | null = null
  templateId: any = 0
  variablesFillsIdent: Array<VariableFill> = []

  QUESTION_TYPES = TemplateQuestionsTypes
  PAGE_SIZE = 25
  PAGE_SEARCHES_SIZE = 100
  FILL_UPDATE_MODE = FILL_UPDATE_MODE
  ORIGIN_PARAM = 'fillgrid'
  NOT_ALLOWED_VIEW = NOT_ALLOWED_VIEW
  DISABLE_FILL_STATUS = ['FNL', 'GEO', 'RVG', 'RCH', 'MRK']

  cursorRequest = new CursorRequest<FillgridFilters>(this.PAGE_SIZE, true)
  filters: FillgridFilters = new FillgridFilters()
  items: Record<string, any>[] = []
  itemsHistory: Record<string, any>[] = []
  cursorHistory = { 1: '' } as any
  pagesLoaded = {} as any
  totalPages = 0
  totalItems = 0
  paginatorKey = 0
  selectedItems: string[] = []
  identsNames: string[] = []
  identsLabels: string[] = []
  toggleAll = false
  loadingData = false
  leftSidebarCollapsed = false
  columnsToShow: any[] = []
  viewSelected = 0
  displayImages = false
  templateTitle = ''
  downloadingFileItem = ''
  downloadingData = false
  downloadCurrentPage = 1

  columns: FillgridColumn[] = []
  noVisibleColumns: string[] = [
    '_priority',
    '_visitedLocation',
    '_fillLocation'
  ]
  users = [] as string[]

  mediaPreviewActive = false
  currentMediaTypeDisplayed = ''
  currentMediaSourceDisplayed: any = {}

  /** Update operations */
  assignationUser = ''
  activeDeleteRows = false
  activeAssignRows = false
  activeUpdateMultipleRows = false
  activeChangeStatusRows = false
  fieldToUpdate = ''
  fieldsListToUpdate: any[] = []
  downloadEmail = ''
  /** Attributes to manage async tasks */
  asyncModalId = 'downloadFillsModal'
  asyncTaskToast = false
  asyncTaskSuccess?: boolean = undefined
  asyncTaskError?: boolean = undefined
  asyncTaskDetails: AsyncTask = AsyncTask.getInstance()
  existTaskInProcess: boolean = false
  attachmentColumns: AttachmentObject[] = []
  selectableAttachments: TemplateQuestionsTypes[] = SelectableAttachments
  // Search Filter
  searches: CustomSearch[] = []
  searchIdSelected: number = UNDEFINED_ENTITY_ID
  creatingSearch: boolean = false
  searchUpdated: number = 0 // 0: init, 1: success, 2: error
  searchError: String = ''
  isUpdating: boolean = false

  autoSaveView: boolean = false

  historyActive = false
  updatesMode: FILL_UPDATE_MODE = FILL_UPDATE_MODE.MODIFY // modificar, gestionar

  /** Integration task */
  integrationModel= false
  integrationTaskModalId = 'integrationTaskModal'
  integrationTaskModalKey = 0

  /** Normalization task */
  listNormalizers: Array<Normalizer> = []
  isGetListNormalizer: boolean = false

  /** Map View */
  mapViewActive: boolean = false
  mapViewVisible: boolean = false

  defaultProbabilityPercentageFTS: number = 50
  probabilityPercentageFTS: number = this.defaultProbabilityPercentageFTS

  beforeCreate () {
    fillgridService.getConfiguration()
      .then((response) => {
        try {
          const FTSvalue = response.configuration.find(config => config.key === CONFIGURATION_KEY.MIS_TAREAS_FTS)?.value
          this.probabilityPercentageFTS = FTSvalue ? parseFloat(FTSvalue) : this.defaultProbabilityPercentageFTS
        } catch (error) {
          LogService.warn(`Error al convertir el valor - configuration - : ${error}`)
        }
      })
      .catch((error) => {
        LogService.warn(`Error al consultar - configuration - : ${error.toString()}`)
      })
  }

  created () {
    this.templateId = this.$route.params.id
    if (this.templateId) {
      fillgridService.getTemplateById(this.templateId).then(
        (template) => {
          this.template = template
          this.templateTitle = `${template.label} [v${template.version}]`
          const columns = fillgridService.getTemplateColumns(template, template.idents)
          this.identsNames = template.idents || []
          this.identsNames.forEach(name => {
            const col = columns.find(it => it.name === name)
            this.identsLabels.push(col ? col.label : '')
          })
          const columnsWithoutBlockedQuestions = columns.filter(column => !this.template?.blockedQuestions?.includes(column.name))
          this.columns = Object.freeze(columnsWithoutBlockedQuestions) as any
          this.noVisibleColumns = this.noVisibleColumns.concat(this.template.blockedQuestions)
          for (let i = 0; i < template.idents.length; i++) {
            this.variablesFillsIdent.push({ variableId: `ident${i}`, variableValue: template.idents[i] })
          }
        }
      )
      let pageRequest = new PageRequest<UserCatalogFilters>()
      if (userInfoStore.userInfo.domain.name === 'root') {
        pageRequest.filters.domainId = cookiesService.get(config.domainIdCookieName)
      }
      this.getUsers(pageRequest)
    }
    this.getAllSearches()
  }

  isDisableFillStatus (status: any): boolean {
    return this.DISABLE_FILL_STATUS.includes(status)
  }

  get userId (): number {
    return userInfoStore.userInfo.id
  }

  getAttachmentsFromColumns (columns: any[], columnsToShow: string[]) : void {
    let attachmentColumns = columns.filter((col) => this.selectableAttachments.includes(col.type))
    if (columnsToShow.length) {
      attachmentColumns = attachmentColumns.filter((column) => columnsToShow.includes(column.name))
    }
    this.attachmentColumns = attachmentColumns.map((column) => {
      return {
        name: column.name,
        label: column.label,
        type: column.type
      } as AttachmentObject
    })
  }

  /* Permissions */

  get fillsViewPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_VIEW)
  }

  get readFillsPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.FILLS_READ)
  }

  get editFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_EDIT)
  }

  get createFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_CREATE) &&
      userInfoStore.hasPermission(PermissionNames.FILLS_EDIT)
  }

  get normalizationPermission () {
    return userInfoStore.hasPermission(PermissionNames.NORMALIZERS_READ)
  }

  get hasTypistPermission () {
    return userInfoStore.hasPermission(PermissionNames.TYPIST_VIEW)
  }

  get updateFillsPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.FILLS_UPDATE)
  }

  /**
   * Valdate if the user has all the permissions to manage fills with
   * quick edit fields
   */
  get hasPermissionToQuickEdit (): boolean {
    const permissions = [
      PermissionNames.FILLS_UPDATE,
      PermissionNames.FILLS_QUICKEDIT
    ]
    return userInfoStore.hasPermissions(permissions)
  }

  /**
   * Validate if there is some quick edit field in the template to manage
   */
  get isThereSomeQuickEditField (): boolean {
    return this.columns.some((column: FillgridColumn) => this.isQuickEditField(column))
  }

  /**
   * Validate if there is some PDF in the template
   */
  get isThereSomePdfField (): boolean {
    return this.columns.some((column: FillgridColumn) => this.isPdfField(column))
  }

  /**
   * Validate if there is some field remaining to select to modify or manage
   */
  get isRemainingColumnsToModifyOrManage (): boolean {
    return this.updatesMode === FILL_UPDATE_MODE.MODIFY
      ? this.columns.some((column: FillgridColumn) => this.isEditableColumn(column))
      : this.columns.some((column: FillgridColumn) => this.isQuickEditEditableColumn(column))
  }

  get deleteFillsPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.FILLS_DELETE)
  }

  get pdfFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_PDF)
  }

  get isEnableTemplate () {
    return this.template?.enabled
  }

  get isWebEnableTemplate () {
    return this.template?.webEnabled
  }

  /**
   * Validate if a template is enable or webEnable.
   * But this is always true for users with role 'operationsAdmin'
   */
  get isEnableOrWebEnableTemplate () {
    return userInfoStore.hasRole(RoleNames.OPERATIONS_ADMIN) || this.isEnableTemplate || this.isWebEnableTemplate
  }

  /**
   * Validates if the user has all the permissions to can modify fills
   */
  get modifyFillsPermission () {
    return this.integrateFillsPermission && userInfoStore.hasPermission(PermissionNames.FILLS_MODIFY) && this.isEnableOrWebEnableTemplate
  }

  get integrateFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_INTEGRATE)
  }

  get assignFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_ASSIGNMENT)
  }

  get readAttachmentsPermission () {
    return userInfoStore.hasPermission(PermissionNames.ATTACHMENTS_READ)
  }

  get integrationTaskPermissions () {
    const requiredPermissions = [
      PermissionNames.INTEGRATION_CREATE,
      PermissionNames.INTEGRATION_UPDATE
    ]
    const minimunPermissions = [
      PermissionNames.FILLS_INTEGRATE,
      PermissionNames.FILLS_ASSIGNMENT
    ]
    return userInfoStore.hasPermissions(requiredPermissions) &&
      minimunPermissions.some(permission => userInfoStore.hasPermission(permission)) && this.isEnableOrWebEnableTemplate
  }

  get isTemplateWithLocation () {
    return this.template && (this.template.fillLocation || this.template.visitedLocation)
  }

  get requiredColumns () {
    return this.columns
      .filter(column => column.ident || column.questionRef?.requiredForIntegration)
      .map(fieldRequired => { return { name: fieldRequired.name, label: fieldRequired.label } })
  }

  get hasPermissionToDownloadAttachments () {
    return userInfoStore.hasPermission(PermissionNames.DATAFEEDATTACH_CREATE)
  }

  /** Return the asyn task modal id */
  get downloadFillsModalId () {
    return '#' + this.asyncModalId
  }

  updateAutoSaveView (value: boolean): void {
    this.autoSaveView = value
  }

  /**
   * Manage the event to show the async task modal
   * @param value true to show, false to hide
  */
  showAsyncTaskModalEvent (value: boolean) {
    const modal = document.getElementById(this.asyncModalId)
    if (value) {
      this.setExistTaskInProcess(this.isSomeTaskInProcess())
      modal!.style.display = 'block'
    } else {
      modal!.style.display = 'none'
    }
  }

  onFinishIntegrationCloseModal () {
    const modal = document.getElementById(this.integrationTaskModalId)
    if (modal) {
      modal.style.display = 'none'
      modal.attributes.removeNamedItem('aria-modal')
      modal.setAttribute('aria-hidden', 'true')
      this.resetIntegrationTaskModal()
    }
  }

  displayIntegrationTaskNotification (integrationTask: AsyncTask) {
    this.showIntegrationToast(
      'Integración iniciada',
      integrationTask.id,
      integrationTask.name,
      integrationTask.updateDate,
      integrationTask.process.requestId)
  }

  showIntegrationToast (title: string, id: number, source: string, date: string, requestId: string) {
    const dateOpts: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
    const dateFormat = Intl.DateTimeFormat('es-MX', dateOpts).format(new Date(`${date}Z`))
    const h = this.$createElement
    const node = h(
      'div', { class: ['d-flex', 'flex-column', 'p-0'] }, [
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `ID:`), `${id}`
        ]),
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Archivo:`), source
        ]),
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Fecha:`), dateFormat
        ]),
        h('p', { class: 'text small m-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Request:`), requestId
        ])
      ])
    this.$bvToast.toast([node], {
      title: `${title}. [Integración]`,
      variant: 'success',
      autoHideDelay: 7500,
      solid: true
    })
  }

  /**
   * Manage the event to show the async task toast whe one was created
   * @param task object returned when the task was created
  */
  showAsyncTaskToast (task: AsyncTask) {
    this.asyncTaskDetails = task
    this.asyncTaskToast = true
    this.asyncTaskSuccess = true
    setTimeout(() => {
      this.hideAsyncTaskToast()
    }, 6000)
  }

  /** Manage the event to hide the async task toast */
  hideAsyncTaskToast () {
    this.asyncTaskDetails = AsyncTask.getInstance()
    this.asyncTaskToast = false
    this.asyncTaskSuccess = undefined
    this.asyncTaskError = undefined
  }

  /**
   * Unshift a search into the current array.
   * This method will be called after a new async task is created with a new search.
   *
   * @param search a search to unshift from the async task modal
   */
  unshiftSearch (search: CustomSearch): void {
    this.searches.unshift(search)
  }

  /**
   * Create a page request configuration to get searches
   */
  preparePageSearchRequest (): PageRequest<FillgridSearchFilters> {
    let pageRequest = new PageRequest<FillgridSearchFilters>()
    pageRequest.size = this.PAGE_SEARCHES_SIZE
    pageRequest.sort = 'name'
    pageRequest.filters.origin = SearchOrigin.FILLGRID
    return pageRequest
  }

  /**
   * Get the searches based on a page request configuration
   *
   * @param pageRequest with config
   */
  async getSearches (pageRequest: PageRequest<FillgridSearchFilters>) {
    await fillgridService.getSearches(this.templateId, pageRequest)
      .then((response) => {
        this.searches.push(...response.results)
        // Continue loading searches if we haven't finished requesting all yet
        if (this.searches.length < response.total) {
          pageRequest.page++
          this.getSearches(pageRequest)
        }
      })
      .catch((error) => {
        LogService.log(`Error al obtener las búsquedas personalizadas: ${error}`)
      })
  }

  /**
   * Call the method to get searches with an request configuration
   */
  async getAllSearches () {
    this.searches = []
    let pageRequest = this.preparePageSearchRequest()
    await this.getSearches(pageRequest)
  }

  /**
   * Set the current searchIdSelected as -1 this indicates
   * that there isn't selected a search
   */
  clearSearchIdSelected () {
    this.setSearchIdSelected(UNDEFINED_ENTITY_ID)
  }

  /**
   * Copy the 'filters' values into the 'filters' variable
   *
   * @param filters values to copy
   */
  setFiltersWith (filters?: FillgridFilters) {
    this.filters = Object.assign({}, filters)
  }

  /**
   * Set the 'creating' value as the state of creating search
   * @param creating value
   */
  setCreatingSearch (creating: boolean) {
    this.creatingSearch = creating
  }

  /**
   * Set the 'state' value to the searchUpdated variable
   *
   * @param state value to set
   */
  setSearchUpdated (state: number) {
    this.searchUpdated = state
  }

  /**
   * Set the 'state' value to the searchUpdated variable
   *
   * @param state value to set
   */
  setUsers (list: Array<string>) {
    this.users = list
  }

  /**
   * Set the 'searchId' value to 'searchIdSelected' variable
   *
   * @param searchId id to set
   */
  setSearchIdSelected (searchId: number): void {
    this.searchIdSelected = searchId
  }

  /**
   * Set the 'viewId' value to 'viewSelected' variable
   *
   * @param viewId to set to the
   */
  setViewIdSelected (viewId: number): void {
    this.viewSelected = viewId
  }

  /**
   * Deletes the search with id 'searchId'
   * and clear the current search selected
   *
   * @param searchId id of the search to delete
   */
  deleteSearch (searchId: number) {
    fillgridService.deleteSearch(this.templateId, searchId)
      .then(() => {
        let index = this.searches.findIndex((search) => search.id === searchId)
        this.searches.splice(index, 1)
      })
      .then(() => {
        this.clearSearchIdSelected()
        this.newSearch(this.filters)
      })
  }

  /**
   * Create or update a search.
   * If the searchId was passed, we try to update the seach.
   * else we create a new one.
   *
   * @param filters values to with create/update a Search
   * @param searchId id of the search to update
   */
  async saveSearch (filters: FillgridFilters, searchId?: number) {
    const search = this.prepareCustomSearch(filters)
    if (searchId && searchId > 0) {
      search.id = searchId
      this.putSearch(searchId, search)
    } else {
      this.postSearch(search)
    }
  }

  putSearch (searchId: number, searchValues: CustomSearch): void {
    fillgridService.updateSearch(this.templateId, searchValues)
      .then((response) => {
        let index = this.searches.findIndex((s) => s.id === searchId)
        this.searches.splice(index, 1, response as CustomSearch)
        this.setSearchIdWithProcessState(response.id, PROCESS_STATUS.SUCCESS)
      })
      .catch((error) => {
        this.handleSearchErrorOnSave(error)
      })
      .finally(() => {
        this.setCreatingSearch(false)
      })
  }

  postSearch (searchValues: CustomSearch): void {
    fillgridService.createSearch(this.templateId, searchValues)
      .then((response) => {
        this.unshiftSearch(response)
        this.setSearchIdWithProcessState(response.id, PROCESS_STATUS.SUCCESS)
      })
      .catch((error) => {
        this.handleSearchErrorOnSave(error)
      })
      .finally(() => {
        this.setCreatingSearch(false)
      })
  }

  setSearchIdWithProcessState (searchId: number, state: PROCESS_STATUS) {
    this.setSearchIdSelected(searchId)
    this.setSearchUpdated(state)
  }

  handleSearchErrorOnSave (error: any) {
    this.manageSearchError(error)
    this.setSearchUpdated(PROCESS_STATUS.ERROR)
  }

  /**
   * Manage an error responsed by the API
   *
   * @param error
   */
  manageSearchError (error: any) {
    let errorData = Object.assign(new APIErrorFormat(), error.response.data)
    if (errorData.isNewErrorFormat()) {
      let blueErrors = errorData.errors
      if (blueErrors.length > 0 && blueErrors[0].code) {
        this.searchError = blueErrors[0].description
      } else {
        this.searchError = blueErrors[0].description
      }
    } else {
      this.searchError = error.response.data.message
    }
  }

  /**
   * Create a CustomSearch based on an object with the values
   *
   * @param filters values from where create a custom search
   */
  prepareCustomSearch (filters: FillgridFilters): CustomSearch {
    return fillgridService.fillgridFiltersToCustomSearch(filters, this.viewSelected)
  }

  backToTemplates () {
    this.$router.push({ name: 'fillgridTemplate' })
  }

  toggleDisplayImages () {
    this.displayImages = !this.displayImages
  }

  /** Items selection */

  /**
   * Reset the selectedItems list to an empty list
   */
  clearSelectedItems (): void {
    this.selectedItems = []
  }

  toggleAllItemsSelection (checked: boolean) {
    this.toggleAll = checked
    if (checked) {
      this.selectedItems = this.items.reduce((arr: any[], it: any) => {
        return arr.concat(it._id)
      }, [])
    } else {
      this.clearSelectedItems()
    }
  }

  selectItem (checked: boolean, item: any) {
    const index = this.selectedItems.indexOf(item._id)
    if (checked && index === -1) {
      this.selectedItems.push(item._id)
    } else if (!checked && index > -1) {
      this.selectedItems.splice(index, 1)
    }
  }

  /** Fetch data */

  /**
   * Updates the fill value by the cookie 'UPDATE_FILL_IN_FILLGRID'
   * if it exists, it contains a 'fillName' value
   */
  async updateManageFill () {
    const fillName = cookiesService.get(BM_COOKIES.UPDATE_FILL_IN_FILLGRID)
    if (fillName) {
      // Get the latest fill
      await fillgridService.getFillDetail(this.templateId, fillName, { last: true })
        .then((fill: any) => {
          // this cookie is not required anymore
          cookiesService.remove(BM_COOKIES.UPDATE_FILL_IN_FILLGRID)
          const fillEntry = fillgridService.getFillsColumnsData(this.columns, fill)
          // Remove the previous fill value and update to the latest
          this.uploadpages(fillEntry[0])
        })
    }
  }

  uploadpages (lastUpdateItem: any) {
    let deleteItem: any
    let addItem, lastDeleteItem
    for (let i = 1; i <= this.cursorRequest.currentPage; i++) {
      addItem = i === 1 ? lastUpdateItem : lastDeleteItem
      deleteItem = i === this.cursorRequest.currentPage ? lastUpdateItem : (this.pagesLoaded[i] as any[])[this.PAGE_SIZE - 1]
      lastDeleteItem = deleteItem
      let newItems: any[] = this.pagesLoaded[i]
      newItems = newItems.filter((f) => f.name !== deleteItem.name)
      newItems.unshift(addItem)
      this.pagesLoaded[i] = newItems
    }
  }

  async loadPage (page: number) {
    this.clearSelectedItems()
    this.cursorRequest.currentPage = page
    if (this.pagesLoaded[this.cursorRequest.currentPage]) {
      this.items = this.pagesLoaded[this.cursorRequest.currentPage]
    } else {
      await this.searchData()
    }
  }

  async changeSize (size:number) {
    this.PAGE_SIZE = size
    this.cursorRequest.limit = this.PAGE_SIZE
    if (this.items.length !== 0) {
      this.newSearch()
    }
  }

  async reloadData () {
    this.clearSelectedItems()
    if (this.cursorHistory.hasOwnProperty(this.cursorRequest.currentPage)) {
      await this.searchData(this.cursorHistory[this.cursorRequest.currentPage])
    } else {
      await this.searchData()
    }
  }

  searchByFTS () {
    const random = Math.random()
    return random < (this.probabilityPercentageFTS / 100)
  }

  async searchData (cursor?: string) {
    if (this.loadingData && !this.downloadingData) return
    this.loadingData = true

    try {
      const byFTS = this.searchByFTS()
      if (this.totalItems === 0) {
        fillgridService.getCountFills(this.templateId, this.cursorRequest, cursor ?? this.cursorRequest.cursor, byFTS)
          .then((total) => {
            this.totalItems = total
            this.totalPages = Math.ceil(this.totalItems / this.cursorRequest.limit)
          })
      }
      const fillgridEntries = await fillgridService.getFills(this.templateId, this.cursorRequest, cursor ?? this.cursorRequest.cursor, byFTS)

      if (!this.cursorHistory.hasOwnProperty(this.cursorRequest.currentPage)) {
        this.cursorHistory[this.cursorRequest.currentPage] = this.cursorRequest.cursor
      }
      this.cursorRequest.cursor = fillgridEntries.nextCursor
      const itemsData = fillgridService.getFillsColumnsData(this.columns, fillgridEntries.results)
      this.pagesLoaded[this.cursorRequest.currentPage] = itemsData
      if (!this.downloadingData) {
        this.items = itemsData
      }

      setTimeout(() => {
        this.loadingData = false
      }, 500)
    } catch (error) {
      this.loadingData = false
      if ((error as any).response.data && (error as any).response.data.errors && (error as any).response.data.errors[0]) {
        let errorMessage = 'Ocurrió un error al consultar los datos'
        switch ((error as any).response.data.errors[0].code) {
          case 1661:
            errorMessage = 'El rango de fechas excede el límite de 90 días'
            break
          case 1665:
            errorMessage = 'No cuenta con permisos para acceder al -user- solicitado'
            break
          case 1707:
            errorMessage = 'No cuenta con permisos para acceder al -altUser- solicitado'
            break
        }

        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 6000,
          toaster: 'b-toaster-top-left'
        })
      } else {
        this.$bvToast.toast('Ocurrió un error al consultar los datos', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 4000,
          toaster: 'b-toaster-top-left'
        })
      }
    }
  }

  getUsers (pageRequest: PageRequest<UserCatalogFilters>) {
    localStorageUser.getListUsers(pageRequest).then(list => {
      this.users = list
    })
  }

  simulateSearch () {
    this.loadingData = true
    if (this.isUpdating) {
      this.updateManageFill()
      this.isUpdating = false
    }
    setTimeout(() => {
      this.paginatorKey = new Date().getTime()
      this.loadPage(1)
      this.loadingData = false
    }, 500)
  }

  newSearch (filters?: FillgridFilters) {
    this.initVariables(filters)
    this.clearSelectedItems()
    this.loadPage(1)
  }

  initVariables (filters?: FillgridFilters) {
    this.setFiltersWith(filters || this.filters)
    this.cursorRequest.filters = this.filters
    this.cursorRequest.currentPage = 1
    this.cursorRequest.cursor = ''
    this.totalItems = 0
    this.totalPages = 0
    this.items = []
    this.pagesLoaded = {}
    this.paginatorKey = new Date().getTime()
    this.downloadCurrentPage = 1
    this.cursorHistory = { 1: '' } as any
  }

  applyView (payload: { selection: any[], viewId: any }) {
    this.columnsToShow = payload.selection
    this.viewSelected = payload.viewId
    this.getAttachmentsFromColumns(this.columns, this.columnsToShow)
  }

  isColumnVisible (columnName: string) {
    return !(this.noVisibleColumns.includes(columnName) ||
      (this.columnsToShow.length && this.columnsToShow.indexOf(FillgridColumn.getColumnName(columnName)) === -1))
  }

  /**
   * Validate if a column will be able to modify
   * We can pass an object with the properties to consider as editable field
   *
   * @param column to valdidate if it is able to edit
   * @param check object with flags to consider
   */
  isEditableColumn (column: FillgridColumn, check: any = { readOnly: true }) {
    if (this.isFieldAlreadySelectedToUpdate(column)) return false
    if (column.isEditableColumnDate()) return true
    if (column.base) return false
    if (column.questionRef.identity) return false
    if (check.readOnly && !column.questionRef.readOnly) return false
    if (
      ['signature', 'photo', 'audio', 'pdf', 'location', 'file'].includes(column.type) ||
      ['_id', '_name', '_priority', '_visitedLocation'].includes(column.name) ||
      !column.label || !column.label.trim()
    ) return false
    return true
  }

  /**
   * Validate if the column is editable in the Modify or Manage actions
   * for the fill records.
   */
  isQuickEditEditableColumn (column: FillgridColumn): boolean {
    const check = { readOnly: false }
    return this.isEditableColumn(column, check) && this.isQuickEditField(column)
  }

  /**
   * Validate when a column (field) is of type quick edit
   * this is: a field of type 'selection' with the 'quickEdit' flag on.
   */
  isQuickEditField (column: FillgridColumn) {
    return column.type === TemplateQuestionsTypes.SELECT &&
      column.questionRef.quickEdit
  }
  /**
   * Validate when a column (field) is of type PDF
   */
  isPdfField (column: FillgridColumn) {
    return column.type === TemplateQuestionsTypes.PDF
  }

  isFieldAlreadySelectedToUpdate (column: FillgridColumn): boolean {
    return this.fieldsListToUpdate.some(it => it.name === column.name)
  }

  validateEditableColumn (column: FillgridColumn): boolean {
    return this.updatesMode === FILL_UPDATE_MODE.MODIFY
      ? this.isEditableColumn(column)
      : this.isQuickEditEditableColumn(column)
  }

  /** Media viewer */

  showMediaViewer (type: TemplateQuestionsTypes, src: any, question: string) {
    if (src === undefined || src === null) { return }
    this.currentMediaTypeDisplayed = type
    this.currentMediaSourceDisplayed = src
    switch (type) {
      case TemplateQuestionsTypes.PHOTO:
      case TemplateQuestionsTypes.AUDIO:
      case TemplateQuestionsTypes.PDF:
        this.fetchFile(src, question).then(url => {
          src.url = url
          this.currentMediaSourceDisplayed = src
          this.$bvModal.show('media-viewer-modal')
        })
        break
      default: // Locations
        this.$bvModal.show('media-viewer-modal')
    }
  }

  getFillColumnDateFormat (date: string, isUTC: boolean, questionFormat?: string) {
    const format = questionFormat ? questionFormat.toLocaleUpperCase() : 'DD/MM/YYYY'
    const strictFormat = questionFormat ? format : undefined
    return isUTC ? moment.utc(date, strictFormat).local().format(format) : moment(date, strictFormat).format(format)
  }

  getFillColumnDateTimeFormat (date: string, isUTC: boolean, questionFormat?: string, timeFormat?:string) {
    const format = questionFormat && timeFormat ? questionFormat.toLocaleUpperCase().concat(' ', timeFormat) : 'DD/MM/YYYY - HH:mm:ss'
    const strictFormat = questionFormat && timeFormat ? format : undefined
    if (!isUTC && date.endsWith('Z')) date = date.replace('Z', '')
    return isUTC ? moment.utc(date, strictFormat).local().format(format) : moment(date, strictFormat).format(format)
  }

  getAllLocationColumns (columnsExceptions: string[]) : any[] {
    return this.columns
      .filter((column) => (column.type === this.QUESTION_TYPES.LOCATION && !columnsExceptions.includes(column.name)) ||
                          (column.type === this.QUESTION_TYPES.PHOTO &&
                              !columnsExceptions.includes(column.name) &&
                              column.questionRef.isLocalized
                          )
      )
  }

  getAllLocationValuesFromFill (fill: any, locationExceptions: string[]) {
    // Name list of all columns of type LOCATION
    const locationColumnNames = this.getAllLocationColumns([
      '_visitedLocation',
      ...locationExceptions
    ]).map((column) => column.name)
    const locationsValues = []
    for (const field in fill) {
      if (locationColumnNames.includes(field)) {
        locationsValues.push({
          label: this.getColumnByName(field)?.label,
          ...fill[field]
        })
      }
    }
    return locationsValues
  }

  getColumnByName (name: string) {
    return this.columns.find((column) => column.name === name)
  }

  get displayImagesBtnTitle () {
    return this.displayImages ? 'Ocultar imágenes' : 'Mostrar imágenes'
  }

  getTitleShowMapView () {
    return this.mapViewActive ? 'Ocultar mapa' : 'Mostrar mapa'
  }

  /** UPDATES */

  openAssignUser () {
    if (this.validateSelection()) {
      this.assignationUser = ''
      this.activeAssignRows = false
      this.$bvModal.show('assign-user-modal')
    }
  }

  async saveAssignationUser () {
    if (this.assignationUser) {
      const fillsItems = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat(it) : arr, [])
      let errorMessages = ''
      let erroresList = []

      this.loadingData = true

      let promises: Promise<any>[] = []

      for (let i = 0; i < fillsItems.length; i++) {
        if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
        promises.push(fillgridService.assignFillToUser(this.templateId, fillsItems[i], this.assignationUser))
      }

      Promise.allSettled(promises).then(results => {
        results.forEach((it) => {
          if (it.status === 'rejected') {
            const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
            if (error && !errorMessages.includes(error)) {
              errorMessages += `\n${error}`
              erroresList.push(error)
            }
          }
        })

        if (errorMessages) {
          this.$bvToast.toast(`Ocurrieron errores al asignar el usuario: \n${errorMessages}`, {
            title: 'Error',
            solid: true,
            variant: 'danger',
            noAutoHide: true,
            bodyClass: 'toast-pre-wrap-content'
          })
        } else {
          this.$bvToast.toast('Los fills han sido asignados correctamente al usuario ' + this.assignationUser, {
            title: 'Listo',
            solid: true,
            variant: 'success',
            autoHideDelay: 4000
          })
        }

        this.$bvModal.hide('assign-user-modal')
        setTimeout(async () => {
          this.loadingData = false
          this.clearSelectedItems()
          await this.reloadData()
        }, 2000)
      })
    }
  }

  /** DELETE */

  openDeleteRows () {
    if (this.validateSelection()) {
      this.activeDeleteRows = false
      this.$bvModal.show('delete-rows-modal')
    }
  }

  async deleteRows () {
    const fillsNames = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat({ id: it._id, name: it._name }) : arr, [])
    let errorMessages = ''
    let erroresList = []

    this.$bvModal.hide('delete-rows-modal')
    this.loadingData = true

    let promises: Promise<any>[] = []

    for (let i = 0; i < fillsNames.length; i++) {
      if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
      promises.push(fillgridService.deleteFill(this.templateId, fillsNames[i].name))
    }

    Promise.allSettled(promises).then(results => {
      results.forEach((it) => {
        if (it.status === 'rejected') {
          const error = (it.reason as any).response!.data!.error
          if (error && !errorMessages.includes(error)) {
            errorMessages += `\n${error}`
            erroresList.push(error)
          }
        }
      })

      if (errorMessages) {
        this.$bvToast.toast(`Ocurrieron errores al eliminar: \n${errorMessages}`, {
          title: 'Error',
          solid: true,
          variant: 'danger',
          noAutoHide: true,
          bodyClass: 'toast-pre-wrap-content'
        })
      } else {
        this.$bvToast.toast('Los registros han sido eliminados correctamente', {
          title: 'Listo',
          solid: true,
          variant: 'success',
          autoHideDelay: 4000
        })
      }

      setTimeout(async () => {
        this.loadingData = false
        this.clearSelectedItems()
        await this.reloadData()
      }, 2000)
    })
  }

  /* HISTORY */

  async showFillHistory () {
    if (!this.historyActive && this.validateSingleSelection()) {
      const fillName = this.items.find(it => it._id === this.selectedItems[0])?._name
      const data = await fillgridService.getFillDetail(this.templateId, fillName, {}) as any
      this.itemsHistory = fillgridService.getFillsColumnsData(this.columns, data)
      this.historyActive = true
    }
  }

  /** UPDATES */

  openUpdatesMultiple (mode: FILL_UPDATE_MODE) {
    this.updatesMode = mode
    if (this.validateSelection()) {
      this.fieldsListToUpdate = []
      this.activeUpdateMultipleRows = false
      this.$bvModal.show('updates-multiple-modal')
    }
  }

  addFieldToUpdate (field: string) {
    const columnConfig = this.columns.find(it => it.name === field) || {} as any
    this.fieldsListToUpdate.push({ name: columnConfig.name, label: columnConfig.label, type: columnConfig.type, questionRef: columnConfig.questionRef, value: this.getDefaultFieldValue(columnConfig.type, columnConfig.questionRef), valid: false })
    this.fieldToUpdate = ''
    setTimeout(() => {
      const id = 'input-update-' + (this.fieldsListToUpdate.length - 1)
      const element = document.getElementById(id)
      if (element) element.focus()
    }, 500)
  }

  getDefaultFieldValue (type: string, questionRef: any) {
    switch (type) {
      case TemplateQuestionsTypes.SELECT:
        if (questionRef.display.format === 'COMBO') {
          if (questionRef.display.type === 'MULTIPLE') {
            return []
          } else {
            return ''
          }
        }
        break
      default:
        return ''
    }
  }

  deleteFieldToUpdate (index: number) {
    this.fieldsListToUpdate.splice(index, 1)
  }

  get existsDisableSelectedItems () {
    return this.getSelectedItems.some((item) => this.DISABLE_FILL_STATUS.includes(item.status))
  }

  get allDisableSelectedItems () {
    return this.getSelectedItems.every((item) => this.DISABLE_FILL_STATUS.includes(item.status))
  }

  get getSelectedItems () {
    return this.items.filter((item) => this.selectedItems.includes(item._id))
  }

  async applyUpdatesMultiple () {
    if (!this.validFields()) {
      this.$bvToast.toast('Algunos valores ingresados no son correctos', {
        title: 'Validación',
        solid: true,
        autoHideDelay: 3500
      })
      return false
    } else {
      const selectedFills = this.getSelectedItems
      const enableFillsByStatus = selectedFills.filter((fill) => !this.isDisableFillStatus(fill.status))
      let errorMessages = ''
      let erroresList = []

      this.loadingData = true
      const changes = this.getFillsChangesObject()

      let promises: Promise<any>[] = []

      if (this.updatesMode === FILL_UPDATE_MODE.MODIFY) {
        for (let i = 0; i < enableFillsByStatus.length; i++) {
          if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
          promises.push(fillgridService.updateFill(this.templateId, enableFillsByStatus[i], changes, this.identsNames))
        }
      } else {
        for (let i = 0; i < enableFillsByStatus.length; i++) {
          if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
          promises.push(fillgridService.manageFill(this.templateId, enableFillsByStatus[i], changes, this.identsNames))
        }
      }

      Promise.allSettled(promises).then(results => {
        results.forEach((it) => {
          if (it.status === 'rejected') {
            const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
            if (error && !errorMessages.includes(error)) {
              errorMessages += `\n${error}`
              erroresList.push(error)
            }
          }
        })

        if (errorMessages) {
          this.$bvToast.toast(`Ocurrieron errores al guardar los datos: \n${errorMessages}`, {
            title: 'Error',
            solid: true,
            variant: 'danger',
            noAutoHide: true,
            bodyClass: 'toast-pre-wrap-content'
          })
        } else {
          this.$bvToast.toast('Los fills se han actualizado correctamente', {
            title: 'Listo',
            solid: true,
            variant: 'success',
            autoHideDelay: 4000
          })
        }

        this.$bvModal.hide('updates-multiple-modal')
        setTimeout(async () => {
          this.loadingData = false
          this.clearSelectedItems()
          await this.reloadData()
        }, 2000)
      })
    }
  }

  getFillsChangesObject () {
    const changes: any = { }
    for (let field of this.fieldsListToUpdate) {
      let value = field.value

      switch (field.type) {
        case this.QUESTION_TYPES.DATE:
          value = moment(field.value).format('YYYY-MM-DD')
          break
        case this.QUESTION_TYPES.DATETIME:
          value = moment(field.value).format('YYYY-MM-DDTHH:mm:ss')
          break
        case this.QUESTION_TYPES.TIME:
          value = moment(field.value).format('HH:mm:ss')
          break
      }
      if (FillgridColumn.isEditableColumnDate(field.name)) {
        changes[field.name] = value
      } else {
        changes[field.questionRef.id] = value
      }
    }
    return changes
  }

  validFields () {
    for (let i = 0; i < this.fieldsListToUpdate.length; i++) {
      if (!this.fieldsListToUpdate[i].valid) {
        return false
      }
    }
    return true
  }

  openChangeStatusRows () {
    if (this.validateSelection()) {
      this.activeChangeStatusRows = false
      this.$bvModal.show('change-status-rows-modal')
    }
  }

  async changeStatusRows () {
    const fillsItems = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat(it) : arr, [])
    let errorMessages = ''
    let errorNotBmp = 'Solo se puede generar PDF a los registros que ya se encuentren gestionados.'
    let erroresList = []
    let successPdf = false

    this.$bvModal.hide('change-status-rows-modal')
    this.loadingData = true

    let promises: Promise<any>[] = []

    for (let i = 0; i < fillsItems.length; i++) {
      if (fillsItems[i]._altUser === 'bmp') {
        if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
        promises.push(fillgridService.changeStatusFilltoFNL(this.templateId, fillsItems[i]))
      } else {
        if (!errorMessages.includes(errorNotBmp)) {
          errorMessages += `\n${errorNotBmp}`
          erroresList.push(errorNotBmp)
        }
      }
    }

    Promise.allSettled(promises).then(results => {
      results.forEach((it) => {
        if (it.status === 'rejected') {
          const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
          if (error && !errorMessages.includes(error)) {
            errorMessages += `\n${error}`
            erroresList.push(error)
          }
        } else {
          successPdf = true
        }
      })

      if (errorMessages) {
        this.$bvToast.toast(`Ocurrieron errores al generar el PDF: \n${errorMessages}`, {
          title: 'Error',
          solid: true,
          variant: 'danger',
          noAutoHide: true,
          bodyClass: 'toast-pre-wrap-content'
        })
      }
      if (successPdf) {
        this.$bvToast.toast(`A los registros se les ha generado el PDF correctamente`, {
          title: 'Listo',
          solid: true,
          variant: 'success',
          autoHideDelay: 4000
        })
      }

      setTimeout(async () => {
        this.loadingData = false
        this.clearSelectedItems()
        await this.reloadData()
      }, 5000)
    })
  }

  /** DOWNLOAD FILES & DATA */

  fetchPhotoPreview (entryColumnValue: any, question: string) {
    this.fetchFile(entryColumnValue, question).then(url => {
      entryColumnValue.url = url
    })
  }

  fetchFile (entryColumnValue: any, question: string) {
    return new Promise((resolve, reject) => {
      if (entryColumnValue.url) {
        resolve(entryColumnValue.url)
      } else {
        fillgridService.getFillgridFileAttachement(entryColumnValue.name, question, this.templateId).then(url => {
          resolve(url)
        })
      }
    })
  }

  downloadFile (name: string, question: string) {
    this.downloadingFileItem = name
    fillgridService.getFillgridFileWithoutTypeAttachement(name, question, this.templateId).then((data: any) => {
      const nameParts = name.split('.')
      let element = this.$refs.fileDownload as any
      element.href = data.url
      element.target = '_blank'
      element.download = nameParts.length > 1 ? name : `${name}.${data.type}`
      element.click()
    }).finally(() => {
      this.downloadingFileItem = ''
    })
  }

  openDownloadFiles () {
    if (this.validateSelection()) {
      this.$bvModal.show('download-files-modal')
    }
  }

  downloadFiles () {
    this.$bvModal.hide('download-files-modal')
    this.$bvToast.toast('La liga para descargar los archivos ha sido enviada al correo proporcionado', {
      title: 'Archivos enviados',
      solid: true,
      autoHideDelay: 4000
    })
  }

  /** POPUPS **/
  baseURLToRedirect (): string {
    return config.isProduction
      ? `https://${config.enviroment}.${config.appDomain}`
      : `http://${config.appDomain}:2680/bmp-3.1`
  }

  openFillDetail (fill: any) {
    if (this.editFillsPermission) {
      let URL = `${this.baseURLToRedirect()}/fill.xsp?view=form&id=${fill._id}&template=${this.templateId}`
      URL = this.addParamsFromFillgrid(URL)
      this.redirectWindowToHref(URL)
    }
  }

  openFillNew () {
    let URL = `${this.baseURLToRedirect()}/fill.xsp?view=form&id=-1&template=${this.templateId}`
    URL = this.addParamsFromFillgrid(URL)
    this.redirectWindowToHref(URL)
  }

  openFillInTypist (fill?: any) {
    if (this.hasTypistPermission) {
      let TYPIST_URL = ''
      // prepare URL base on the fill
      if (fill === undefined) {
        TYPIST_URL = `${this.baseURLToRedirect()}/typist.xsp?fillName=new&template=${this.templateId}`
      } else {
        TYPIST_URL = `${this.baseURLToRedirect()}/typist.xsp?fillName=${fill._name}&template=${this.templateId}`
      }
      // TYPIST_URL = this.addParamsFromFillgrid(TYPIST_URL)
      // redirect to the URL
      this.redirectWindowToHref(TYPIST_URL)
      this.isUpdating = true
    } else {
      if (fill === undefined) {
        this.openFillNew()
      } else {
        this.openFillDetail(fill)
      }
    }
  }

  @Provide()
  readonly openFillInTypistFromMap = this.openFillInTypist

  addOriginParamToURL (url: string, origin: string) {
    return url + `&origin=${origin}`
  }

  addPageHistoryParamToURL (url: string, index: number) {
    return url + `&page-history=${index}`
  }

  addParamsFromFillgrid (url: string) {
    url = this.addOriginParamToURL(url, this.ORIGIN_PARAM)
    url = this.addPageHistoryParamToURL(url, NUMBER.ONE)
    return url
  }

  redirectWindowToHref (href: string) {
    if (window.top!) {
      window.top!.location.href = href
    } else {
      window.location.href = href
    }
  }

  /** UTIL METHODS **/

  validateSelection (): boolean {
    if (this.selectedItems.length) {
      return true
    } else {
      this.$bvToast.toast('Seleccione al menos un registro', {
        title: 'Acción requerida',
        solid: true,
        variant: 'warning',
        autoHideDelay: 3200
      })
      return false
    }
  }

  validateSingleSelection (): boolean {
    if (this.selectedItems.length === 1) {
      return true
    } else {
      this.$bvToast.toast('Seleccione un registro en específico', {
        title: 'Acción requerida',
        solid: true,
        variant: 'warning',
        autoHideDelay: 3200
      })
      return false
    }
  }

  getFieldSelectPriorityValue (options: any, propertyValue: string) {
    for (let it of Object.entries(options)) {
      if (it[1] === propertyValue) return it[0]
    }
    return ''
  }

  isSomeTaskInProcess (): boolean {
    return this.$store.getters['taskNotifications/isDatafeedTaskInProcess']
  }

  setExistTaskInProcess (value: boolean): void {
    this.existTaskInProcess = value
  }

  currencyFormat (value: number | undefined, maxDecimal: number): string {
    if (value === undefined) return ''
    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'MXN', maximumFractionDigits: maxDecimal ?? 21, minimumFractionDigits: maxDecimal }
    const currencyFormatMX = new Intl.NumberFormat('es-MX', options)
    return currencyFormatMX.format(value)
  }

  decimalFormat (value: number | undefined, maxDecimal: number): string {
    if (value === undefined) return ''
    return maxDecimal ? value.toFixed(maxDecimal) : value.toString()
  }

  integerFormat (value: number | undefined): string {
    if (value === undefined) return ''
    const options: Intl.NumberFormatOptions = { style: 'decimal', maximumFractionDigits: 0, minimumFractionDigits: 0 }
    const currencyFormatMX = new Intl.NumberFormat('es-MX', options)
    return currencyFormatMX.format(value)
  }

  resetIntegrationTaskModal () {
    this.integrationTaskModalKey++
    this.$bvModal.hide('modalIntegration')
  }

  reloadNormalizers () {
    this.isGetListNormalizer = false
    this.loadNormalizers()
  }

  loadNormalizers () {
    fillgridService.getNormalizers(this.templateId).then((response) => {
      this.listNormalizers = response.results
    }).finally(() => {
      this.isGetListNormalizer = true
    })
  }

  openModalIntegration () {
    this.integrationModel = true
    if (this.normalizationPermission && !this.isGetListNormalizer) {
      this.loadNormalizers()
    }
  }

  /**
   * Prepares the payload to show a location question in the media previewer
   *
   * @param value property of fill row
   * @param item fill row
   * @param index property column index
   */
  getLocationPayload (value: any, item: any, index: number) {
    return {
      location: Object.assign({}, value, { label: this.columns[index]?.label }),
      refLocation: Object.assign({}, item._visitedLocation, { label: this.getColumnByName('_visitedLocation')?.questionRef?.label }),
      locations: this.getAllLocationValuesFromFill(item, [this.columns[index]?.name])
    }
  }

  /**
   * Prepares the payload to show a photo question with or without location in the media previewer
   *
   * @param value property of fill row
   * @param item fill row
   * @param index property column index
   */
  getPhotoPayload (value: any, item: any, index: number) {
    if (this.columns[index]?.questionRef?.isLocalized) {
      return Object.assign({}, value, { locations: this.getAllLocationValuesFromFill(item, [this.columns[index]?.name]), label: this.columns[index]?.questionRef?.label })
    } else {
      return value
    }
  }
}
